/**
 * Constants related to the progress bar component
 */

import type { ProgressConfig } from '@/core/types';

/**
 * Default configuration for the NProgress library
 */
export const PROGRESS_CONFIG: ProgressConfig = {
  showSpinner: false,
};
